import { createFileRoute } from "@tanstack/react-router";
import { UserManagement } from "../app/views/management/userManagement";

export const Route = createFileRoute("/users")({
  component: UserManagement,
});
